var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('icon',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",value:({
		html:true,
		title:_vm.text,
		interactive:false,
		variant:'light'
	}),expression:"{\n\t\thtml:true,\n\t\ttitle:text,\n\t\tinteractive:false,\n\t\tvariant:'light'\n\t}",modifiers:{"hover":true}}],staticClass:"text-light",staticStyle:{"font-size":"1rem","opacity":"0.5"},attrs:{"name":"mdi.information-outline"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }